import t from "react";
import { alertAtom as l } from "./index51.mjs";
import { stepAtom as a } from "./index25.mjs";
import { useSetAtom as e } from "jotai";
import i from "./index224.mjs";
import o from "./index225.mjs";
import { AlertContent as m } from "./index32.mjs";
const g = () => {
  const n = e(a), r = e(l), s = () => {
    n(0);
  };
  return /* @__PURE__ */ t.createElement("div", { className: o.container, "data-testid": "no-results" }, /* @__PURE__ */ t.createElement(
    m,
    {
      classes: o.alert,
      title: I18n.t("booking_engine.search.no_results.title"),
      subTitle: I18n.t("booking_engine.search.no_results.sub_title"),
      icon: i,
      actions: [
        {
          label: I18n.t("booking_engine.search.no_results.button_label"),
          onClick: s
        }
      ],
      setAlertData: r
    }
  ));
};
export {
  g as NoResults
};
